import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./UserLogin.css";
import UserLogo from "./UserLoginLogo.png";
import axios from "axios";
import { Api } from "../../../Admin/BackendApi/api";
import { APP_VERSION } from "../../../Admin/Pages/Version Provider/VersionConfig";
import ConfirmPopup from "../../../Admin/Component/ConfirmPopup/ConfirmPopup";

const UserLogin = () => {

    const [mobile, setMobile] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [versionCode] = useState(APP_VERSION);

    const [popup, setPopup] = useState({
        show: false,
        message: "",
        type: "error",
    });

    const navigate = useNavigate();

    const handleSendOtp = async () => {

        const mobileStr = mobile.toString().trim();

        if (!/^\d{10}$/.test(mobileStr)) {
            setError("Please enter a valid 10-digit mobile number");
            return;
        }

        try {

            setError("");
            setLoading(true);

            const response = await axios.post(Api.userLogin, {
                Mobile: mobileStr,
                VersionCode: versionCode,
            });


            if (response.data.status === 0) {

                setPopup({
                    show: true,
                    message: (
                        <>
                            <span style={{ fontSize: "20px" }}>❌</span>{" "}
                            {response.data.message}
                        </>
                    ),
                    type: "error",
                });

                setLoading(false);
                return;
            }

            if (response.data.status === 1) {

                localStorage.setItem("mobile", mobileStr);

                navigate("/user/otp", {
                    state: {
                        mobile: mobileStr,
                        userId: response.data.user._id,
                    },
                });

            }

        } catch (err) {

            console.log(err);

            setPopup({
                show: true,
                message: "Server error. Try again.",
                type: "error",
            });

            setLoading(false);
        }
    };

    const handlePopupClose = () => {
        setPopup({ ...popup, show: false });
    };

    return (

        <div className="user-login-container">

            {!loading && (

                <div className="user-login-card">

                    <div className="user-logo-section">
                        <img src={UserLogo} alt="Logo" className="user-logo" />
                    </div>

                    <input
                        type="tel"
                        placeholder="Enter Mobile Number"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        className="user-login-input"
                    />

                    {error && <div className="user-error-msg">{error}</div>}

                    <button
                        className="user-login-button"
                        onClick={handleSendOtp}
                    >
                        Send OTP
                    </button>

                </div>
            )}

            {loading && (
                <div className="user-spinner-overlay">
                    <div className="user-spinner"></div>
                    <div className="user-sending-text">Sending OTP...</div>
                </div>
            )}

            <div className="user-version-text">Version {versionCode}</div>

            <ConfirmPopup
                show={popup.show}
                message={popup.message}
                type={popup.type}
                onClose={handlePopupClose}
            />

        </div>
    );
};

export default UserLogin;